import {
  Button,
  Card,
  Flex,
  Heading,
  PencilIcon,
  Skeleton,
  Text,
} from '@buffer-mono/popcorn'

import { NewPostComposerTrigger } from '~publish/components/NewPostComposerTrigger'
import AppActionCreators from '~publish/legacy/composer/composer/action-creators/AppActionCreators'

import { useFilteredTemplates } from './useFilteredTemplates'

import styles from './TemplateSuggestion.module.css'

import type { JSX } from 'react'

const handleCreatePost = (): void => {
  // Temporary hack to ensure the omnibox is enabled
  // when the new post composer is opened
  // Since it is not immediately enabled, we need to wait for it to be enabled
  const start = Date.now()
  const interval = setInterval(() => {
    AppActionCreators.updateOmniboxState(true)
    if (Date.now() - start > 2000) {
      clearInterval(interval)
    }
  }, 200)
}

const NUM_TEMPLATES_TO_SHOW = 1

export const TemplateSuggestion = ({
  preselectChannelId,
}: {
  preselectChannelId?: string
}): JSX.Element => {
  const { templates, loading } = useFilteredTemplates(NUM_TEMPLATES_TO_SHOW)
  const template = templates[0]

  if (loading) return <Skeleton height={140} />
  if (!template) return <div>No template found</div>

  return (
    <Card asChild className={styles.card}>
      <article>
        <Flex
          direction="column"
          justify="between"
          gap="xs"
          className={styles.grow}
        >
          <Flex direction="column" gap="xs" className={styles.grow}>
            <Text color="subtle" size="sm">
              Create a new post based on this prompt:
            </Text>
            <Heading size="xs" className={styles.templateTitle}>
              {template.title}
            </Heading>
            <Flex gap="md" justify="between" fullWidth>
              <Text size="sm" className={styles.templateDescription}>
                {template.description}
              </Text>
              <NewPostComposerTrigger
                channels={preselectChannelId ? [preselectChannelId] : undefined}
                prefillPostData={{ text: template.body }}
                cta="create-templates-dialog-newPost-1"
                templateId={template.id}
              >
                <Button
                  variant="secondary"
                  size="medium"
                  onClick={handleCreatePost}
                  className={styles.templateButton}
                >
                  <PencilIcon />
                  Use This Template
                </Button>
              </NewPostComposerTrigger>
            </Flex>
          </Flex>
        </Flex>
      </article>
    </Card>
  )
}
